/* nebe — landing „tělová“
   Vše scope-ováno na kořen sekce, ať jde sekce vložit i vícekrát. */
(function () {
  var productCache = {};

  // Stoq (Restock Rocket): openModal(produkt, variantId) — zjištěno z app embedu.
  // Bez appky (nebo když se nenačte) padáme na produktovku s předvybranou variantou.
  function openWatchForm(handle, variantId) {
    var fallback = function () { window.location = '/products/' + handle + '?variant=' + variantId; };
    var api = window._Stoq || window._RestockRocket;
    if (!api || typeof api.openModal !== 'function') return fallback();

    var open = function (product) {
      try { api.openModal(product, Number(variantId)); }
      catch (e) { fallback(); }
    };
    if (productCache[handle]) return open(productCache[handle]);
    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) { productCache[handle] = p; open(p); })
      .catch(fallback);
  }

  /* ---------- FULLSCREEN GALERIE (lightbox) ----------
     Přenesené z produktovky (nebe-pdp.js): jeden prvek na <body>, vodorovný track
     se scroll-snapem. Listování prstem tak obstará prohlížeč sám, šipky a Esc jsou
     navíc. Sem se to nedalo naimportovat — nebe-pdp.js si žádá window.PRODUCT
     a na /pages/* se vůbec nenačítá. */
  var _lb = null;
  var _lbLastFocus = null;
  var _lbTexts = { close: 'Zavřít', prev: '‹', next: '›', label: '' };

  // hodnoty jdou do innerHTML — texty i URL projdou přes escape atributu
  function attrEsc(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;');
  }

  function lbTrack() { return _lb ? _lb.querySelector('[data-lb-track]') : null; }
  function lbCount() {
    var tr = lbTrack();
    if (!tr || !tr.clientWidth) return;
    var c = _lb.querySelector('[data-lb-count]');
    if (c) c.textContent = Math.round(tr.scrollLeft / tr.clientWidth) + 1 + '/' + tr.children.length;
  }
  function lbGo(dir) {
    var tr = lbTrack();
    if (!tr || !tr.clientWidth) return;
    var idx = Math.round(tr.scrollLeft / tr.clientWidth) + dir;
    var t = Math.max(0, Math.min(tr.children.length - 1, idx));
    if (tr.scrollTo) tr.scrollTo({ left: t * tr.clientWidth, behavior: 'smooth' });
    else tr.scrollLeft = t * tr.clientWidth;
  }
  function lbClose() {
    if (!_lb) return;
    _lb.classList.remove('is-open');
    document.documentElement.style.overflow = '';   // odemkni scroll stránky
    if (_lbLastFocus && _lbLastFocus.focus) _lbLastFocus.focus();
    _lbLastFocus = null;
  }
  function lbBuild() {
    _lb = document.createElement('div');
    _lb.className = 'nebe-lp-lightbox';
    _lb.setAttribute('role', 'dialog');
    _lb.setAttribute('aria-modal', 'true');
    _lb.innerHTML =
      '<button class="nebe-lp-lightbox__close" type="button" aria-label="' + attrEsc(_lbTexts.close) + '">&times;</button>' +
      '<button class="nebe-lp-lightbox__nav nebe-lp-lightbox__nav--prev" type="button" aria-label="' + attrEsc(_lbTexts.prev) + '">&lsaquo;</button>' +
      '<button class="nebe-lp-lightbox__nav nebe-lp-lightbox__nav--next" type="button" aria-label="' + attrEsc(_lbTexts.next) + '">&rsaquo;</button>' +
      '<div class="nebe-lp-lightbox__track" data-lb-track></div>' +
      '<div class="nebe-lp-lightbox__count" data-lb-count></div>';
    document.body.appendChild(_lb);

    _lb.querySelector('.nebe-lp-lightbox__close').addEventListener('click', lbClose);
    _lb.querySelector('.nebe-lp-lightbox__nav--prev').addEventListener('click', function () { lbGo(-1); });
    _lb.querySelector('.nebe-lp-lightbox__nav--next').addEventListener('click', function () { lbGo(1); });
    _lb.addEventListener('click', function (e) { if (e.target === _lb) lbClose(); });
    var track = lbTrack();
    track.addEventListener('scroll', lbCount, { passive: true });
    // klik do tmavého pozadí vedle fotky zavírá
    track.addEventListener('click', function (e) { if (!e.target.closest('img')) lbClose(); });

    document.addEventListener('keydown', function (e) {
      if (!_lb.classList.contains('is-open')) return;
      if (e.key === 'Escape') lbClose();
      else if (e.key === 'ArrowLeft') lbGo(-1);
      else if (e.key === 'ArrowRight') lbGo(1);
      else if (e.key === 'Tab') {
        // fokus uvězněný uvnitř: fokusovatelná jsou jen tři tlačítka
        var f = [].slice.call(_lb.querySelectorAll('button')).filter(function (b) { return b.offsetParent !== null; });
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        else if (!_lb.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
      }
    });
  }
  function openLightbox(images, startIdx, label, alt) {
    images = (images || []).filter(Boolean);
    if (!images.length) return;
    if (!_lb) lbBuild();
    _lb.setAttribute('aria-label', label || _lbTexts.label || '');
    var track = lbTrack();
    var altAttr = attrEsc(alt);
    track.innerHTML = images.map(function (src, i) {
      return '<div class="nebe-lp-lightbox__slide"><img src="' + attrEsc(src) + '" alt="' + altAttr + '"'
        + (i === 0 ? '' : ' loading="lazy"') + ' decoding="async"></div>';
    }).join('');
    _lbLastFocus = document.activeElement;
    _lb.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';   // zamkni scroll pozadí
    var closeBtn = _lb.querySelector('.nebe-lp-lightbox__close');
    if (closeBtn && closeBtn.focus) closeBtn.focus();
    requestAnimationFrame(function () {
      track.scrollLeft = (startIdx || 0) * track.clientWidth;
      lbCount();
    });
  }

  function init(root) {
    if (root.dataset.lpReady === '1') return;
    root.dataset.lpReady = '1';

    // popisky lightboxu si bere z kořene sekce (v JS není přístup k Liquidu)
    if (root.dataset.lbClose) _lbTexts.close = root.dataset.lbClose;
    if (root.dataset.lbPrev) _lbTexts.prev = root.dataset.lbPrev;
    if (root.dataset.lbNext) _lbTexts.next = root.dataset.lbNext;
    if (root.dataset.lbLabel) _lbTexts.label = root.dataset.lbLabel;

    var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* ---- odhalování při scrollu ---- */
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('in');
        io.unobserve(e.target);
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -6% 0px' });
    root.querySelectorAll('.rv').forEach(function (el) { io.observe(el); });

    /* ---- ručně kreslená zvýraznění: dokreslí se při vstupu do viewportu ---- */
    var ioHl = new IntersectionObserver(function (en) {
      en.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        setTimeout(function () { el.classList.add('is-drawn'); }, 260);
        ioHl.unobserve(el);
      });
    }, { threshold: 0.9 });
    root.querySelectorAll('[data-hl]').forEach(function (el) { ioHl.observe(el); });

    /* ---- spodní lišta na mobilu ----
       Mizí v sekci s dlaždicemi, kde má návštěvnice tlačítka přímo u produktů. */
    var bar = root.querySelector('[data-lp-bar]');
    if (bar) {
      var inCards = false;
      var updateBar = function () {
        bar.classList.toggle('is-on', scrollY > innerHeight * 0.85 && !inCards);
      };
      var cardsSection = root.querySelector('#lp-strihy');
      if (cardsSection) {
        new IntersectionObserver(function (en) {
          en.forEach(function (e) { inCards = e.isIntersecting; });
          updateBar();
        }, { rootMargin: '-12% 0px -22% 0px' }).observe(cardsSection);
      }
      addEventListener('scroll', updateBar, { passive: true });
      updateBar();
    }

    /* ---- test bílého trička: porovnávací posuvník ---- */
    var stage = root.querySelector('[data-lp-stage]');
    if (stage) {
      var layer = stage.querySelector('[data-lp-layer]');
      var handle = stage.querySelector('[data-lp-handle]');
      var markL = stage.querySelector('[data-lp-mark="l"]');
      var markR = stage.querySelector('[data-lp-mark="r"]');

      var setSplit = function (pct) {
        pct = Math.max(0, Math.min(100, pct));
        layer.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
        handle.style.left = pct + '%';
        handle.setAttribute('aria-valuenow', Math.round(pct));
        if (markL) markL.style.opacity = pct > 28 ? '1' : '0';
        if (markR) markR.style.opacity = pct < 72 ? '1' : '0';
      };
      var pctFrom = function (ev) {
        var b = stage.getBoundingClientRect();
        return ((ev.clientX - b.left) / b.width) * 100;
      };

      var dragging = false, idle = null, t0 = null;
      var idleStop = function () { if (idle) { cancelAnimationFrame(idle); idle = null; } };
      var idleLoop = function (ts) {
        if (t0 === null) t0 = ts;
        setSplit(52 + Math.sin(((ts - t0) / 3600) * Math.PI * 2) * 30);
        idle = requestAnimationFrame(idleLoop);
      };

      stage.addEventListener('pointerdown', function (ev) {
        dragging = true; idleStop(); setSplit(pctFrom(ev));
        if (stage.setPointerCapture) stage.setPointerCapture(ev.pointerId);
        ev.preventDefault();
      });
      stage.addEventListener('pointermove', function (ev) { if (dragging) setSplit(pctFrom(ev)); });
      addEventListener('pointerup', function () { dragging = false; });
      stage.addEventListener('pointerenter', idleStop);

      handle.addEventListener('keydown', function (e) {
        var cur = parseFloat(handle.style.left) || 58;
        if (e.key === 'ArrowLeft') { idleStop(); setSplit(cur - 4); e.preventDefault(); }
        if (e.key === 'ArrowRight') { idleStop(); setSplit(cur + 4); e.preventDefault(); }
      });

      setSplit(58);
      if (!reduce) {
        new IntersectionObserver(function (en) {
          en.forEach(function (e) {
            if (e.isIntersecting && !idle && !dragging) { t0 = null; idle = requestAnimationFrame(idleLoop); }
            else if (!e.isIntersecting) idleStop();
          });
        }, { threshold: 0.4 }).observe(stage);
      }
    }

    /* ---- z úvodní mozaiky na dlaždici produktu ---- */
    root.querySelectorAll('[data-lp-jump]').forEach(function (link) {
      link.addEventListener('click', function (ev) {
        var target = root.querySelector(link.getAttribute('href'));
        if (!target) return;                       // bez cíle nechá projít běžnou kotvu
        ev.preventDefault();
        target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
        history.replaceState(null, '', link.getAttribute('href'));
        target.classList.remove('is-landed');
        void target.offsetWidth;                   // restart animace při opakovaném kliknutí
        target.classList.add('is-landed');
        setTimeout(function () { target.classList.remove('is-landed'); }, 3100);
      });
    });

    /* ---- tabulka velikostí ---- */
    var modal = root.querySelector('[data-lp-modal]');
    if (modal) {
      var lastFocus = null;
      var openModal = function (btn) {
        lastFocus = btn;
        modal.setAttribute('open', '');
        document.body.style.overflow = 'hidden';
        modal.querySelector('[data-lp-modal-close]').focus();
      };
      var closeModal = function () {
        modal.removeAttribute('open');
        document.body.style.overflow = '';
        if (lastFocus) lastFocus.focus();
      };
      root.querySelectorAll('[data-lp-size-open]').forEach(function (b) {
        b.addEventListener('click', function () { openModal(b); });
      });
      modal.querySelectorAll('[data-lp-modal-close]').forEach(function (b) {
        b.addEventListener('click', closeModal);
      });
      addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && modal.hasAttribute('open')) closeModal();
      });
    }

    /* ---- výběr velikosti + do košíku ---- */
    root.querySelectorAll('[data-lp-card]').forEach(function (card) {
      var form = card.querySelector('form[data-lp-form]');
      if (!form) return;
      var idInput = form.querySelector('input[name="id"]');
      var btn = form.querySelector('[data-lp-atc]');
      var btnLabel = btn.querySelector('[data-lp-atc-label]');
      var note = card.querySelector('[data-lp-note]');
      var noteText = note ? note.textContent : '';
      var noteTimer = null;
      var sizesBox = card.querySelector('.sizes');

      function restoreNote() {
        if (!note) return;
        clearTimeout(noteTimer);
        note.textContent = noteText;
        note.classList.remove('is-warn');
      }
      function warnNote(msg) {
        if (!note) return;
        clearTimeout(noteTimer);
        note.textContent = msg;
        note.classList.add('is-warn');
        noteTimer = setTimeout(restoreNote, 3000);
      }
      // upozornění na nevybranou velikost: zatřesení blokem + červené dlaždice (stejně jako na produktovce)
      function bumpSizes() {
        if (!sizesBox) return;
        sizesBox.classList.add('nag');
        setTimeout(function () { sizesBox.classList.remove('nag'); }, 1500);
        if (!reduce && sizesBox.animate) {
          sizesBox.animate([
            { transform: 'translateX(0)' }, { transform: 'translateX(-9px)' },
            { transform: 'translateX(9px)' }, { transform: 'translateX(-7px)' },
            { transform: 'translateX(7px)' }, { transform: 'translateX(-3px)' },
            { transform: 'translateX(0)' }
          ], { duration: 620, easing: 'ease-in-out' });
        }
      }
      var pickLabel = btn.dataset.labelPick;
      var addLabel = btn.dataset.labelAdd;
      var doneLabel = btn.dataset.labelDone;

      /* ---- přepínání barvy: fotka, cena i velikosti se překreslí ---- */
      var colorData = null;
      var colorEl = card.querySelector('[data-lp-colors]');
      if (colorEl) { try { colorData = JSON.parse(colorEl.textContent); } catch (e) { colorData = null; } }
      var imgA = card.querySelector('.card__media img.a');
      var imgB = card.querySelector('.card__media img.b');
      var priceEls = [card.querySelector('.card__price'), card.querySelector('.card__onphoto-price')];
      var sizesBoxEl = card.querySelector('.sizes');

      function renderColor(key) {
        var data = colorData && colorData[key];
        if (!data) return;
        if (imgA) {
          imgA.src = data.front; imgA.alt = data.alt || '';
          if (data.fp) imgA.style.objectPosition = data.fp;
        }
        if (imgB) {
          imgB.src = data.back || data.front;
          if (data.fpBack || data.fp) imgB.style.objectPosition = data.fpBack || data.fp;
        }
        var firstPrice = data.sizes.length ? data.sizes[0].price : null;
        if (firstPrice) priceEls.forEach(function (el) { if (el) el.textContent = firstPrice; });

        sizesBoxEl.innerHTML = data.sizes.map(function (v) {
          var cls = 'sz' + (v.av ? (v.low ? ' low' : '') : ' out');
          return '<button type="button" class="' + cls + '" data-lp-size="' + v.id + '" aria-pressed="false"'
            + (v.av ? '' : ' data-lp-soldout="1"') + '>' + v.t + '</button>';
        }).join('');
        bindSizes();
        idInput.value = '';
        setMode(null);
        activeColor = key;   // galerie i odkaz na detail jedou za zvolenou barvou
        syncLinks();
      }

      var watchLabel = btn.dataset.labelWatch;
      var watchHint = btn.dataset.labelWatchHint;
      var handle = card.dataset.lpHandle;

      /* ---- odkaz na produktový detail ----
         Server vykreslí první dostupnou variantu zvolené barvy; tady ho držíme
         v souladu s tím, co má návštěvnice právě navolené v dlaždici. */
      var activeColor = card.dataset.lpColorActive || '';
      var plinks = [].slice.call(card.querySelectorAll('[data-lp-plink]'));
      var productPath = plinks.length
        ? plinks[0].getAttribute('href').split('?')[0]
        : '/products/' + handle;

      function currentVariantId() {
        if (idInput.value) return idInput.value;                 // vybraná dostupná velikost
        if (card.dataset.lpWatch) return card.dataset.lpWatch;   // vybraná vyprodaná velikost
        var d = colorData && colorData[activeColor];
        if (!d || !d.sizes || !d.sizes.length) return null;
        for (var i = 0; i < d.sizes.length; i++) { if (d.sizes[i].av) return d.sizes[i].id; }
        return d.sizes[0].id;
      }
      function syncLinks() {
        var id = currentVariantId();
        if (!id) return;                       // beze zjištěné varianty nechá serverový odkaz být
        var href = productPath + '?variant=' + id;
        plinks.forEach(function (a) { a.setAttribute('href', href); });
      }
      syncLinks();

      /* ---- klik na fotku → fullscreen galerie zvolené barvy ---- */
      var zoomBtn = card.querySelector('[data-lp-gallery]');
      if (zoomBtn) {
        zoomBtn.addEventListener('click', function () {
          var d = colorData && colorData[activeColor];
          var imgs = d && d.gallery && d.gallery.length ? d.gallery : null;
          if (!imgs) {                                   // záloha: aspoň to, co je na dlaždici
            var shown = card.querySelector('.card__media img.a');
            imgs = shown ? [shown.currentSrc || shown.src] : [];
          }
          openLightbox(
            imgs, 0,
            (_lbTexts.label || '').replace('[name]', card.dataset.lpName || ''),
            (d && d.alt) || card.dataset.lpName || ''
          );
        });
      }

      function setMode(soldOutVariant) {
        if (soldOutVariant) {
          card.dataset.lpWatch = soldOutVariant;
          idInput.value = '';
          btn.classList.add('btn--watch');
          if (btnLabel) btnLabel.textContent = watchLabel;
          if (note && watchHint) { note.textContent = watchHint; note.classList.remove('is-warn'); }
        } else {
          delete card.dataset.lpWatch;
          btn.classList.remove('btn--watch');
          if (btnLabel) btnLabel.textContent = addLabel;
          restoreNote();
        }
      }

      function bindSizes() {
      card.querySelectorAll('[data-lp-size]').forEach(function (sz) {
        sz.addEventListener('click', function () {
          card.querySelectorAll('[data-lp-size]').forEach(function (o) {
            o.classList.remove('is-on');
            o.setAttribute('aria-pressed', 'false');
          });
          sz.classList.add('is-on');
          sz.setAttribute('aria-pressed', 'true');
          btn.classList.remove('is-warn');

          if (sz.dataset.lpSoldout) {
            setMode(sz.dataset.lpSize);       // vyprodaná velikost → hlídací pes
          } else {
            idInput.value = sz.dataset.lpSize;
            setMode(null);
          }
          syncLinks();                        // odkaz na detail míří na právě vybranou variantu
        });
      });
      }
      bindSizes();

      card.querySelectorAll('[data-lp-color]').forEach(function (sw) {
        sw.addEventListener('click', function () {
          card.querySelectorAll('[data-lp-color]').forEach(function (o) {
            o.classList.remove('is-on');
            o.setAttribute('aria-pressed', 'false');
          });
          sw.classList.add('is-on');
          sw.setAttribute('aria-pressed', 'true');
          renderColor(sw.dataset.lpColor);
        });
      });

      form.addEventListener('submit', function (ev) {
        if (card.dataset.lpWatch) {
          ev.preventDefault();
          openWatchForm(handle, card.dataset.lpWatch);
          return;
        }
        if (!idInput.value) {
          ev.preventDefault();
          warnNote(btn.dataset.labelHint || '');
          bumpSizes();
          var first = card.querySelector('[data-lp-size]:not(.out)');
          if (first) first.focus();
          return;
        }
        if (!window.fetch) return; // bez fetch necháme projít klasický submit

        ev.preventDefault();
        btn.disabled = true;

        // sidecart motivu (Be Yours), stejný postup jako na produktovce
        var drawer = document.querySelector('mini-cart')
          || document.querySelector('cart-drawer')
          || document.querySelector('cart-notification');

        var formData = new FormData(form);
        if (drawer && typeof drawer.getSectionsToRender === 'function') {
          formData.append('sections', drawer.getSectionsToRender().map(function (x) { return x.id; }));
          formData.append('sections_url', window.location.pathname);
          if (typeof drawer.setActiveElement === 'function') drawer.setActiveElement(document.activeElement);
        }

        var addUrl = '/cart/add.js';
        try {
          if (typeof theme !== 'undefined' && theme.routes && theme.routes.cart_add_url) addUrl = theme.routes.cart_add_url;
        } catch (e) {}

        fetch(addUrl, {
          method: 'POST',
          headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
          body: formData
        })
          .then(function (r) { return r.json(); })
          .then(function (response) {
            if (response.status) {                       // třeba když mezitím došel sklad
              warnNote(response.description || response.message || '');
              return;
            }
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              try {
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'nebe-lp-telova',
                  productVariantId: formData.get('id'),
                  cart: response
                });
              } catch (e) {}
            }
            if (btnLabel) btnLabel.textContent = doneLabel;
            btn.classList.add('is-done');
            setTimeout(function () {
              btn.classList.remove('is-done');
              if (btnLabel) btnLabel.textContent = addLabel;
            }, 2200);

            if (drawer && typeof drawer.renderContents === 'function') {
              drawer.classList.remove('is-empty');
              drawer.renderContents(response);           // otevře sidecart
            } else {
              window.location = '/cart';                 // jen kdyby sidecart na stránce nebyl
            }
          })
          .catch(function () { form.submit(); })
          .finally(function () { btn.disabled = false; });
      });
    });
  }

  var boot = function () {
    document.querySelectorAll('[data-nebe-lp]').forEach(init);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  // Theme editor: sekce se překresluje
  document.addEventListener('shopify:section:load', boot);
})();
